import React from 'react';
import '@/App.css';

import LandingPage from '@/LandingPage';

// PreventiApp — Root App
// Modo estático (REACT_APP_STATIC_SITE=true, build para SiteGround):
//   Sólo renderiza <LandingPage />. Ninguna dependencia de auth / supabase /
//   admin se importa. El bundle queda mínimo y autocontenido.
//
// Modo SaaS (default, app.preventiapp.com en Emergent):
//   Se carga vía require() dinámico dentro de la rama else. Webpack elimina
//   la rama en el build estático (DefinePlugin reemplaza el env por literal
//   'true', y la rama alternativa se poda).

function App() {
  if (process.env.REACT_APP_STATIC_SITE === 'true') {
    return (
      <div className="App">
        <LandingPage />
      </div>
    );
  }
  // eslint-disable-next-line global-require
  const AppSaaS = require('@/App.saas').default;
  return (
    <div className="App">
      <AppSaaS />
    </div>
  );
}

export default App;
